import React, { useMemo, useState } from "react"
import styled, { useTheme } from '~/ui/styled'
import { Flex, StartFlex, GradientButton, Image, Text, CenterFlex, ColumnFlex } from "~components/El"
import { GradientCardFooter } from "./gradient-card-footer"
import { MessageProps } from "./message.props"
import { observer } from "mobx-react-lite"
import MessageSent from "./message-sent"
import MessageReceived from "./message-received"
import { useStores } from "~models"
import { useChatList } from "~hooks/useChatList"
import useGroupActions from "~hooks/useGroupActions"
import { TransferStatus } from "~proto"
import { globalToast } from "~utils"

const successIcon = require("../../assets/images/chat/redlogo.png")
const failIcon = require("../../assets/images/chat/warning.png")


const MainWrap = styled.View`
  align-items: center;
`

// 红包消息
export const TransMessage: React.FC<MessageProps> = observer(({ message }) => {
  const { userStore } = useStores()
  const theme = useTheme()
  const { created, attach = {}, sender = {}, receiver = {} } = message
  const transInfo = attach?.trans_info
  const { openTransferPopup, openTransferDetailPopup } = useChatList()
  const { handleTransferDetail } = useGroupActions()
  const [loading, setLoading] = useState(false)
  // const [transStatus] = useState(transInfo?.status)


  const isReceiver = receiver?.id === userStore.currentUser?.id // 接收方是否是自己
  const isSender = sender?.id === userStore.currentUser?.id // 发送方是否是自己
  const StatusDesc = useMemo(() => {
    if (transInfo?.status === TransferStatus.PENDING) {
      // 待领取
      if (isReceiver) {
        return "等待确认"
      } else if (isSender) {
        return `给${receiver.name}转账`
      } else {
        return "转账"
      }
    } else if (transInfo?.status === TransferStatus.RECEIVED) {
      return "已领取"
    } else if (transInfo?.status === TransferStatus.EXPIRED) {
      return "已过期"
    } else if (transInfo?.status === TransferStatus.REFUNDED) {
      return "已退回"
    } else {
      return ""
    }
    
  }, [transInfo, isReceiver, isSender])

  const disabled = useMemo(() => {
    return [TransferStatus.RECEIVED, TransferStatus.EXPIRED, TransferStatus.REFUNDED].includes(transInfo?.status)
  }, [transInfo?.status])
  
  return (
    <GradientButton
        contentLayout="fill"
        width="100%"
       maxWidth="400px"
        minWidth="260px"
        height="88px"
        colors={['#3acb6a', '#1ba54a']}
        disabled={loading}
        style={{ opacity: disabled ? 0.8 : 1 }}
        onClick={() => {
          if (loading) return
          setLoading(true)
          handleTransferDetail({
              order_no: transInfo?.order_no
            },(data) => {
              const transferData = data?.transfer_data
              // 该转账是否是自己的转账
              const isTransfer = transferData?.sender_id === userStore.currentUser?.id 
              if (isSender || isTransfer) {
                // 发送者可以查看详情
                openTransferDetailPopup({ message, transferData })
              } else if (isReceiver) {
                if (transferData?.status === TransferStatus.PENDING) {
                  openTransferPopup({ message })
                } else {
                  // 接收者可以查看详情
                  openTransferDetailPopup({ message, transferData })
                }
                
              }
              setLoading(false)
              if (transferData?.status !== TransferStatus.PENDING) {
                message?.setTransInfo({ status: transferData.status })
              }
            }, (error) => {
              setLoading(false)
              globalToast.show(error?.message || "请求失败")
            })
        }}
       
    >
      <StartFlex flexDirection="column" flex={1} width="100%" padding="4px 12px">
        <Flex width="100%" padding="8px 0">
          <CenterFlex width="36px" height="36px" flexShrink={0}>
            <Image
              width="100%"
              height="100%"
              src={transInfo?.status === TransferStatus.EXPIRED ? failIcon : successIcon}
            />
          </CenterFlex>
          <ColumnFlex height="auto" flexDirection="column" ml="8px" style={{ flex: 1, minWidth: 0, paddingRight: 5 }}>
            <Text numberOfLines={1} fontSize={theme.fontSizes.lg} color={theme.colors.textLight} fontWeight={600}>
              ¥ {transInfo?.amount || "0"}
            </Text>
            {StatusDesc ? (
              <Text numberOfLines={1} fontSize={theme.fontSizes.sm} color={theme.colors.textLight}>
                {StatusDesc}
              </Text>
            ) : null}
          </ColumnFlex>
        </Flex>
        <GradientCardFooter label="企鹅转账" time={created} textColor={theme.colors.textLight} />
      </StartFlex>
    </GradientButton>
  )
})

export const WrappedTransMessage: React.FC<MessageProps> = (props) => {
  return (
    <MainWrap>
      {props.message.byMe ? (
        <MessageSent {...props} Component={TransMessage} isNoBg={true} />
      ) : (
        <MessageReceived {...props} Component={TransMessage} isNoBg={true} />
      )}
    </MainWrap>
  )
}
export default WrappedTransMessage
